export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /app/src/app/components/app-breadcrumbs/index.ts